module.exports = __webpack_public_path__ + "img/step-repeat-zh.907756de.webp";